import styles from "./Button.module.css";

// variant: primary (filled) | outline (brand text, soft border) | ghost (white text, no visible border)
// size: md (16px) | sm (14px, used inside cards)
export default function Button({
  as: Component = "button",
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}) {
  const variantClass = variant === "primary" ? "" : styles[variant];
  const sizeClass = size === "sm" ? styles.sm : "";

  return (
    <Component className={`${styles.button} ${variantClass} ${sizeClass} ${className}`} {...props}>
      {children}
    </Component>
  );
}
